export default __webpack_public_path__ + "static/media/1.78fc7cda.jpg";